import React from 'react'
import { Translate } from 'react-redux-i18n'
import { changeStep, steps } from '../../actions/ticket-sale-steps'
import BasePrice from './ticket-base-price'
import LastSellDate from './ticket-sell-date'
import MaxPrice from './ticket-max-price'
import SummaryFooter from './ticket-sell-summary-footer'

const SellForm = props => {
  const {
    boundary,
    currentPhase,
    dispatch,
    eventInfo,
    pricingPolicy,
    selectedDate,
    sellPrice,
    sellIndividually,
    tickets,
    ticketCode,
    ticket,
    ticketsToSell
  } = props

  const endSaleDate = eventInfo && eventInfo.end_sale_date

  const footerSellPrice = sellIndividually ? sellPrice : sellPrice * tickets.length

  return (
    <React.Fragment>
      {sellIndividually ? (
        <h3 className="text-center">
          <Translate value="tickets.ticket_id" id={ticketCode} />
        </h3>
      ) : null}
      <BasePrice
        thisPhase={() => dispatch(changeStep(steps.basePrice))}
        nextPhase={() => dispatch(changeStep(steps.lastSellDate))}
        visible={currentPhase === steps.basePrice}
        ticketPrice={ticket.sum}
        dispatch={dispatch}
        sellPrice={sellPrice}
        sellIndividually={sellIndividually}
        pricingPolicy={pricingPolicy}
        ticketCode={ticketCode}
        tickets={tickets}
      />

      <MaxPrice
        dispatch={dispatch}
        ticketCode={ticketCode}
        sellPrice={sellPrice}
        ticketPrice={ticket.sum}
        pricingPolicy={pricingPolicy}
        visible={currentPhase === steps.minMaxPrice}
        tickets={tickets}
        sellIndividually={sellIndividually}
        boundary={
          sellIndividually
            ? ticketsToSell[ticketCode] && ticketsToSell[ticketCode].boundary
            : boundary
        }
      />

      <LastSellDate
        thisPhase={() => dispatch(changeStep(steps.lastSellDate))}
        nextPhase={() => dispatch(changeStep(steps.accountNumber))}
        visible={currentPhase === steps.lastSellDate}
        dispatch={dispatch}
        selectedDate={selectedDate}
        datePickerFocused={
          ticketsToSell[ticketCode]
            ? ticketsToSell[ticketCode].datePickerFocused
            : false
        }
        endSaleDate={endSaleDate}
        ticketCode={ticketCode}
        tickets={tickets}
        sellIndividually={sellIndividually}
      />

      <SummaryFooter sellPrice={footerSellPrice} selectedDate={selectedDate} />
    </React.Fragment>
  )
}

export default SellForm
